module.exports = __webpack_public_path__ + "img/app-store-badge-us-black.1e08e0af.svg";